import {Action} from "redux-actions";
import {QUOTE_DETAILS_FETCHED, QUOTE_FINANCE_PRODUCT_UPDATED} from "./actionType";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import QuoteDetails from "../../../model/quote/QuoteDetails";

/**
 * Quote details fetch successful action.
 * @param {QuoteDetails} quoteDetails
 * @returns {Action<QUOTE_DETAILS_FETCHED>}
 */
export function quoteDetailsFetched(quoteDetails: QuoteDetails): Action<QUOTE_DETAILS_FETCHED> {
	return {type: QUOTE_DETAILS_FETCHED, payload: {quoteDetails}};
}

/**
 * Update quote finance product successful action.
 * @param quoteId
 * @param financeProductId
 * @returns {Action<QUOTE_FINANCE_PRODUCT_UPDATED>}
 */
export function quoteFinanceProductUpdated(quoteId: string, financeProductId: string): Action<QUOTE_FINANCE_PRODUCT_UPDATED> {
	return {type: QUOTE_FINANCE_PRODUCT_UPDATED, payload: {quoteId, financeProductId}};
}

/**
 * Fetch quote details action
 * @param {string} quoteId
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @returns {(dispatch: Dispatch<any>) => void}
 */
export function fetchQuoteDetails(quoteId: string, onSuccess: OnSuccessData<QuoteDetails>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.quoteApi.fetchQuoteDetails(quoteId)
			.then((quoteDetails) => {
				dispatch(quoteDetailsFetched(quoteDetails));
				onSuccess(quoteDetails);
			}).catch(onFailure);
	}
}

export function updateQuoteFinanceProduct(quoteId: string, financeProductId: string, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.quoteApi.updateQuoteFinanceProduct(quoteId, financeProductId)
			.then(() => {
				dispatch(quoteFinanceProductUpdated(quoteId, financeProductId));
				onSuccess();
			}).catch(onFailure);
	}
}
